import { render } from "./BasicCustomerInfo.vue?vue&type=template&id=1d66d240&scoped=true&lang=pug"
import script from "./BasicCustomerInfo.vue?vue&type=script&lang=js"
export * from "./BasicCustomerInfo.vue?vue&type=script&lang=js"

import "./BasicCustomerInfo.vue?vue&type=style&index=0&id=1d66d240&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d66d240"]])

export default __exports__